import styled from "@mui/material/styles/styled";

import VideoMetricOverlay from "@app/analytics/MeetingReport/components/VideoMetricOverlay";
import { getMetricMetaById } from "@app/analytics/meetops/metrics";

import Stack from "@rui/Stack";

import useVideoMetricOverlays from "./useVideoMetricOverlays";

const Container = styled(Stack)({
  position: "absolute",
  bottom: 66,
  left: 0,
  padding: "8px",
  transition: "opacity 0.2s ease-in-out",
});

const VideoMetrics = () => {
  const metricOverlays = useVideoMetricOverlays();

  return (
    <Container spacing="2px" className="video-metrics">
      {Object.entries(metricOverlays).map(([metricName, value]) => (
        <VideoMetricOverlay
          key={metricName}
          label={
            getMetricMetaById(metricName as keyof typeof metricOverlays)
              .displayName
          }
          value={value}
        />
      ))}
    </Container>
  );
};

export default VideoMetrics;
